// Constants for the application
export const STANDARD_PRICE = 1000;
export const SLIDE_INTERVAL_MS = 4000;

export const siteConfig = {
  name: "Elina K. Photography",
  domain: "www.revoltdigital.me",
  fullUrl: "https://www.revoltdigital.me",
  description: "Professional family portrait photography in UAE. Capturing your family's precious moments with high-quality digital photography - indoor, outdoor, and studio sessions available.",
  email: "revoltdigitalphoto@proton.me",
  phone: "+971 58 674 3237",
  whatsapp: "971586743237",
  location: "Dubai, UAE",
  instagram: "@elina.dubai.photo",
  aboutImage: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/bbfuiz2f_IMG_4762.jpeg"
};

export const currency = {
  symbol: 'AED',
  name: 'UAE Dirham'
};

export const photos = [
  // Outdoor Category
  {
    id: 29,
    title: "Three Hearts, One Sunset",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/497ei16d_IMG_4763.jpeg",
    description: "A young family huddles together in the warm desert light. Big smiles and golden hour glow.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 30,
    title: "On Daddy's Shoulders",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/hepq75q1_IMG_4764.jpeg",
    description: "Little one riding high as the family poses on the beach at sunset. Playful and full of warmth.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 31,
    title: "Run to the Sea",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/kbe9acoq_IMG_4765.jpeg",
    description: "A mother with her baby watches her son race across the sand at dusk. Pure, candid joy.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 32,
    title: "Giggles by the Window",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/uiwjb4jt_IMG_4766.jpeg",
    description: "Mother and daughter share a laugh in soft window light. A bright, airy in-home family session.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 33,
    title: "Tickle Time",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/vvhk0e4x_IMG_4767.jpeg",
    description: "Parents cuddle their laughing toddler at home. Real moments, real happiness.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 34,
    title: "Chasing Bubbles",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/z3g8npf5_IMG_4768.jpeg",
    description: "A mother blows bubbles for her little one in the park. Simple play, endless wonder.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 35,
    title: "Higher, Mama!",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/ozz0a7c4_IMG_4769.jpeg",
    description: "Squeals of laughter on the playground swing. Golden light and pure toddler joy.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 36,
    title: "First Birthday Picnic",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/a6n15g8y_IMG_4770.jpeg",
    description: "Cake smash in the park, black and white. A first birthday celebrated with laughter.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 37,
    title: "Piggyback at Sunset",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/yel0cyfn_IMG_4771.jpeg",
    description: "A family strolls across the sand as the sun dips low. Backlit, breezy and carefree.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 38,
    title: "Kisses on the Rocks",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/jhsn5udj_IMG_4772.jpeg",
    description: "A little boy kisses his dad while mum laughs beside them. Warm evening light by the sea.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 39,
    title: "Garden Afternoon",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/4im32rk3_IMG_4773.jpeg",
    description: "A family of three relaxes on the lawn among the palms. Soft evening light and easy smiles.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 1,
    title: "Joyful Beach Moments",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/40j9zsbz_0E5A1109.jpeg",
    description: "Candid family beach photo capturing pure joy and connection. Beautiful golden hour lighting with ocean backdrop.",
    size: "High Resolution (6000x4000px)",
    format: "Digital Download"
  },
  {
    id: 2,
    title: "Seaside Family Walk",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/opbv4p7z_0E5A1430.jpeg",
    description: "Stunning beachside family photo at sunset. Natural poses and genuine smiles in a beautiful coastal setting.",
    size: "High Resolution (5000x3333px)",
    format: "Digital Download"
  },
  {
    id: 3,
    title: "Father & Daughter Bond",
    category: "outdoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/yymqftm4_0E5A2253-2.jpeg",
    description: "Heartwarming outdoor photo of father and daughter with city skyline. Perfect blend of urban and family connection.",
    size: "High Resolution (6000x4000px)",
    format: "Digital Download"
  },
  
  // Indoor Category (Newborns)
  {
    id: 13,
    title: "Mother's Embrace",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/gf41kw7b_IMG_4747.jpeg",
    description: "A mother holds her sleeping newborn close in soft natural light. Quiet, tender and timeless.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 14,
    title: "Tiny Fingers",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/aefrlrqz_IMG_4748.jpeg",
    description: "Black and white detail of a newborn gripping her mother's finger. The smallest gestures, captured forever.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 15,
    title: "Welcome Home",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/uw66sexn_IMG_4745.jpeg",
    description: "New parents cradle their baby girl at home. An intimate first family portrait filled with love.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 16,
    title: "Safe on Daddy's Shoulder",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/o0x5j4ba_IMG_4746.jpeg",
    description: "A newborn sleeps peacefully on her father's shoulder. Soft black and white tones for a classic feel.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 6,
    title: "Newborn with Father",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/rd351yyg_0E5A8356.jpeg",
    description: "Tender moment of father cradling newborn baby. Soft indoor lighting creates an intimate atmosphere.",
    size: "High Resolution (4500x3000px)",
    format: "Digital Download"
  },
  {
    id: 7,
    title: "Family Love in Home",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/u1naq5tp_0E5A3647.jpeg",
    description: "Beautiful indoor family session in their home. Natural light and authentic moments of love and connection.",
    size: "High Resolution (5000x3333px)",
    format: "Digital Download"
  },
  {
    id: 8,
    title: "Family Hands Together",
    category: "indoor",
    price: STANDARD_PRICE,
    image: "https://customer-assets.emergentagent.com/job_revolt-digital/artifacts/v3v6g4q7_5eee713a-6012-4595-9a69-7000013016d3.jpeg",
    description: "Artistic detail shot of family hands together. Symbolizes unity, love, and family bonds.",
    size: "High Resolution (4500x3000px)",
    format: "Digital Download"
  },
  
  // Studio Category (Maternity)
  {
    id: 17,
    title: "Glow of Motherhood",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/0654t5yu_IMG_4750.jpeg",
    description: "A mother-to-be cradles her bump in soft studio light. Calm, elegant and full of anticipation.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 18,
    title: "First Kiss",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/ozuubj8l_IMG_4751.jpeg",
    description: "A father kisses the baby bump in classic black and white. A tender moment before the first hello.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 19,
    title: "Together, Waiting",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/7feey94l_IMG_4752.jpeg",
    description: "An intimate maternity portrait of the couple at home, wrapped in soft window light.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 21,
    title: "Baby's Breath",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/tgmm4rih_IMG_4754.jpeg",
    description: "Black and white detail of the bump with a bouquet of baby's breath. Simple and timeless.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 20,
    title: "Quiet Afternoon",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/t6ljstwc_IMG_4753.jpeg",
    description: "Relaxed maternity session on the sofa, bathed in natural daylight. Effortless and real.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 22,
    title: "Gentle Hands",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/7etz9f2v_IMG_4755.jpeg",
    description: "Black and white close-up of a mother's hands resting on her bump. Quiet, intimate and full of love.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },
  {
    id: 23,
    title: "Soft Light, Soft Smile",
    category: "studio",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/rwn90yto_IMG_4756.jpeg",
    description: "A mother-to-be gazes down at her bump in a bright, airy room. Natural light and a peaceful moment.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download",
    additionalNote: "Studio booking fees apply and will be added to the final cost"
  },

  // Couples Category
  {
    id: 24,
    title: "The Question",
    category: "couples",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/n9r5kz3r_IMG_4758.jpeg",
    description: "A surprise proposal on the Dubai shoreline. Pure disbelief and joy, captured in the moment.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 25,
    title: "Golden Hour Kiss",
    category: "couples",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/bzhrf34w_IMG_4761.jpeg",
    description: "A soft kiss in warm evening light on the beach. Romantic, relaxed and effortlessly elegant.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 26,
    title: "She Said Yes",
    category: "couples",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/vl1ex39m_IMG_4760.jpeg",
    description: "Swept off her feet by the water. Laughter and love right after the proposal.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 27,
    title: "Dance on the Sand",
    category: "couples",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/845pbkwh_IMG_4759.jpeg",
    description: "A playful twirl on the beach in classic black and white. Movement, joy and the sea breeze.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  },
  {
    id: 28,
    title: "Lazy Afternoon",
    category: "couples",
    price: STANDARD_PRICE,
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/s5uzxvzb_IMG_4757.jpeg",
    description: "Lying in the grass, laughing together. A candid, easy-going couples moment.",
    size: "High Resolution (4000x6000px)",
    format: "Digital Download"
  }
];

export const categories = [
  { id: 'all', name: 'All Photos', icon: 'ImageIcon' },
  { id: 'outdoor', name: 'Families', icon: 'TreesIcon' },
  { id: 'indoor', name: 'Newborns', icon: 'HomeIcon' },
  { id: 'studio', name: 'Maternity', icon: 'CameraIcon' },
  { id: 'couples', name: 'Couples', icon: 'HeartIcon' }
];

export const testimonials = [];

export const faqItems = [
  {
    id: 'faq-2',
    question: "Where do the photoshoots take place?",
    answer: "Photoshoots can be held outdoors, at a studio, or at a location of your choice. I'm happy to suggest beautiful spots based on your preferences."
  },
  {
    id: 'faq-3',
    question: "What should I wear for the photoshoot?",
    answer: "Once your booking is confirmed, I'll send you tips on choosing outfits. I'm always happy to help you decide based on your vision and the location."
  },
  {
    id: 'faq-4',
    question: "When will I receive my edited photos?",
    answer: "You'll receive fully edited photos within 10 days via your private online gallery."
  },
  {
    id: 'faq-5',
    question: "Do you travel for photoshoots?",
    answer: "Yes! I'm happy to travel within and outside of Dubai. Travel fees may apply depending on the location."
  }
];
